import cx from 'classnames'
import dynamic from 'next/dynamic'
import { useContext, useEffect } from 'react'

import { SanityVideoType } from '@data/sanity/queries/types/video'
import { SiteContext } from '@lib/site-context'
import { getMuxVideoAspectRatio } from '@lib/video'

import Icon from '@components/icon'
const MuxPlayer = dynamic(() => import('@components/video/mux-player'))

const VideoModal = () => {
  const { videoModal, toggleVideoModal } = useContext(SiteContext)

  useEffect(() => {
    document.body.classList.toggle('overflow-hidden', videoModal.isOpen)
  }, [videoModal.isOpen])

  const close = () => {
    toggleVideoModal(false)
  }

  const videoAspectRatio = videoModal.video?.muxVideo
    ? getMuxVideoAspectRatio(videoModal.video.muxVideo)
    : undefined

  return (
    <div
      className={cx(
        'fixed inset-0 w-full h-full py-10 z-90',
        'flex items-center justify-center flex-wrap overflow-y-scroll no-scrollbar',
        'bg-backdrop bg-opacity-90 backdrop-blur-[6px]',
        {
          hidden: !videoModal.isOpen,
          block: videoModal.isOpen,
        },
      )}
    >
      <button
        onClick={close}
        className="fixed top-4 right-4 rounded-full bg-white text-black w-10 h-10 md:w-14 md:h-14 flex items-center justify-center z-10"
      >
        <Icon name="X" className="h-4 w-4 md:h-5 md:w-5" />
      </button>

      <div
        className="relative h-[80dvh] max-w-[80vw]"
        style={{
          aspectRatio: videoAspectRatio,
        }}
      >
        {videoModal.video?.muxVideo &&
          videoModal.video.type === SanityVideoType.MUX && (
            <MuxPlayer
              assetDocument={videoModal.video.muxVideo.asset}
              showControls={false}
              showCustomControls
              autoplay
              autoplayOnHover={false}
              openModalOnClick={false}
              loop={false}
              muted={false}
              videoStyle={{
                objectFit: 'cover',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                height: '100%',
                width: '100%',
              }}
            />
          )}
      </div>
    </div>
  )
}

export default VideoModal
